import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';

import TextArea from '@travelnest/merlin.text-area';
import { startCase } from 'lodash';
import React, { useState } from 'react';
import { IEventV2 } from '../../../../data/entities/event';
import { IEventNote } from '../../../../data/entities/event/event-note';
import { FormRow, FormSelect } from '../../form';
import { EVENT_NOTE_TYPES, validateNoteLength } from './helpers';

interface INewEventNoteComponentProps {
	expanded: boolean;
	event: IEventV2;
	submitEventNote: (payments: IEventNote, eventId: string) => void;
}

export const NewEventNoteComponent: React.FC<INewEventNoteComponentProps> = (props) => {
	const [EventNoteType, setEventNoteType] = useState(EVENT_NOTE_TYPES[0]);
	const [content, setContent] = useState('');

	const classList = [
		'event-notes__group',
		...(props.expanded ? [] : ['event-notes__group--hidden'])
	];

	const min = 0;
	const max = 500;

	return <div className={classList.join(' ')}>
		<FormRow>
			<FormSelect value={EventNoteType} onChange={(e) => setEventNoteType(e.target.value)}>
				{EVENT_NOTE_TYPES.map((t) => <option key={t} value={t}>{startCase(t)}</option>)}
			</FormSelect>
		</FormRow>

		<FormRow>
			<TextArea
			id="text-area-component"
			valid = {validateNoteLength(content, min, max)}
			value = {content}
			minLength = { min }
			maxLength = { max }
			errorMessage = {`Note length must be between ${min} and ${max} characters`}
			onChange={(_, value) => setContent(value)}
			/>
		</FormRow>

		<FormRow>
			<Button
				bgColor={theme.colours.neutral.darker}
				color={theme.colours.text.lightest}
				hoverColor={theme.colours.neutral.dark}
				onClick={(e) => props.submitEventNote(
					{
						event_id: props.event.id,
						note_type: EventNoteType,
						content
					} as IEventNote,
					props.event.id
				)}
			>Submit</Button>
		</FormRow>
	</div>;
};
